import { QueryClientProvider } from '@tanstack/react-query';
import '../styles/globals.css';
import { queryClient } from './lib/query-client';
import { ErrorBoundary } from './pages/_error';
import { AppProvider } from './providers/app.provider';
import { ThemeProvider } from './providers/theme/theme.provider';
import { Router } from './routes/router';

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AppProvider>
            <Router />
          </AppProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
